import React from 'react';
import useLiveValue from '../useLiveValue';
import useMeterField from '../useMeterField';

const ComparisonWidget = ({ config }) => {
    const { settings = {}, dataSource = {}, title } = config;
    const baseCurrent = dataSource.current ?? 0;
    const isPreview = typeof config.id === 'string' && config.id.startsWith('preview-');
    const report = useMeterField(title, { meterId: settings.meterId, skip: Boolean(dataSource.endpoint) || isPreview });
    const liveValue = useLiveValue(baseCurrent, {
        id: config.id, endpoint: dataSource.endpoint || (report.field ? 'report' : ''), min: 0, max: Math.max(baseCurrent * 2, 1), volatility: 0.03,
    });
    const current = report.field
        ? Number((report.latest ?? 0).toFixed(1))
        : Number(liveValue.toFixed(1));
    const previous = report.field
        ? Number((report.points[0]?.value ?? 0).toFixed(1))
        : (dataSource.previous ?? 0);
    const delta = previous ? Number((((current - previous) / previous) * 100).toFixed(1)) : 0;
    const isUp = delta >= 0;

    return (
        <div className="comparison-widget" title={`${settings.currentLabel || 'Today'}: ${current}${settings.unit || ''} vs ${settings.previousLabel || 'Yesterday'}: ${previous}${settings.unit || ''}`}>
            <div className="comparison-widget__col">
                <div className="comparison-widget__label">{settings.currentLabel || 'Today'}</div>
                <div className="comparison-widget__value">{current}{settings.unit ? ` ${settings.unit}` : ''}</div>
            </div>
            <div className={`comparison-widget__delta${isUp ? ' comparison-widget__delta--up' : ' comparison-widget__delta--down'}`}>
                <i className={`fas fa-arrow-${isUp ? 'up' : 'down'}`}></i>
                <span>{Math.abs(delta)}%</span>
            </div>
            <div className="comparison-widget__col">
                <div className="comparison-widget__label">{report.field ? 'Start of window' : (settings.previousLabel || 'Yesterday')}</div>
                <div className="comparison-widget__value comparison-widget__value--muted">{previous}{settings.unit ? ` ${settings.unit}` : ''}</div>
            </div>
        </div>
    );
};

export default ComparisonWidget;
